import clickElement from "./click-element";
import Audio from "../../lib/audio";
import Cartoon from '../avatar-action';

/**
 * 新建自定义积木块时，点击上面的确定按钮完成创建
 * @returns {Promise}
 */
export default function clickCustomProcedureOkButton(args) {
    if (!args.tips) args.tips = '点击「确定」按钮，完成创建';
    Audio.tts(args.tips);
    return clickElement({element: '[class^="custom-procedures_ok-button"]', ...args});
}
